<template>
    <table-component
        :loading="loading"
        :pagination="pagination"
        @fetch="fetch"
        :headers="[
            'Produto',
            ''
        ]"
    >
        <template v-for="product in products" :key="product.id">
            <tr class="cursor-pointer" @click="toggleExpand(product)">
                <td class="table-cell">
                    <div class="flex items-center">
                        <ChevronDownIcon v-if="expanded[product.id]" class="h-4 w-4 mr-2 text-slate-400" />
                        <ChevronRightIcon v-else class="h-4 w-4 mr-2 text-slate-400" />
                        <img
                            v-if="product.cover_picture"
                            :src="product.cover_picture"
                            class="object-contains"
                            style="width: 64px !important; height: 64px !important;"
                        >
                        {{product.id}} - {{product.name}}
                    </div>
                </td>
                <td class="table-cell" @click.stop>
                    <toggle-product
                        :product="product"
                        @fetch="fetch"
                    ></toggle-product>
                </td>
            </tr>
            <tr v-if="expanded[product.id]">
                <td colspan="2" class="table-cell bg-slate-900/25">
                    <div v-if="offersLoading[product.id]" class="flex items-center gap-2 text-sm text-slate-400 py-2">
                        <div class="h-2 w-24 animate-pulse rounded bg-gray-500"></div>
                        Carregando ofertas...
                    </div>
                    <div v-else-if="!offersCache[product.id] || offersCache[product.id].length === 0" class="text-sm text-slate-400 py-2">
                        Nenhuma oferta cadastrada para este produto.
                    </div>
                    <table v-else class="w-full text-sm">
                        <thead>
                            <tr>
                                <th class="text-left p-2 text-xs text-slate-400">Código</th>
                                <th class="text-left p-2 text-xs text-slate-400">Nome</th>
                                <th class="text-left p-2 text-xs text-slate-400">Preço</th>
                                <th class="text-left p-2 text-xs text-slate-400">Ativa?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="offer in offersCache[product.id]"
                                :key="offer.id"
                                class="cursor-pointer hover:bg-slate-700/40"
                                @click="openOfferModal(offer)"
                            >
                                <td class="p-2">{{offer.code}}</td>
                                <td class="p-2">{{offer.name}}</td>
                                <td class="p-2">{{ $root.formatCurrency(offer.price) }}</td>
                                <td class="p-2">{{offer.is_active ? 'Sim' : 'Não'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </template>
    </table-component>

    <offer-detail-modal
        :open="showOfferModal"
        :offer="selectedOffer"
        @close="showOfferModal = false"
    ></offer-detail-modal>
</template>

<script>
import { useToast } from "vue-toastification";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";
import HelperMixin from "../../../mixins/HelperMixin.vue";
import ToggleProduct from "../../../components/layouts/ToggleProduct.vue";
import TableComponent from "../../../components/layouts/table/TableComponent.vue";
import OfferDetailModal from "../../../components/product/OfferDetailModal.vue";

export default {
    props: ['user'],
    components: {TableComponent, ToggleProduct, OfferDetailModal, ChevronDownIcon, ChevronRightIcon},
    mixins: [HelperMixin],

    setup() {
        const toast = useToast();

        return { toast };
    },

    data() {
        return {
            loading: false,
            products: [],
            next_page_url: false,
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11
            },
            expanded: {},
            offersCache: {},
            offersLoading: {},
            showOfferModal: false,
            selectedOffer: null,
        }
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;

            const params = {};
            params['page'] = this.pagination.current_page;

            axios.get('/api/user/' + this.user.id + '/product', {
                params: params
            }).then(({data}) => {
                this.products = data.data;

                this.pagination = {
                    ...this.pagination,
                    ...data
                };

                this.next_page_url = data.next_page_url;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
            });
        },

        toggleExpand(product) {
            this.expanded[product.id] = !this.expanded[product.id];

            if (this.expanded[product.id] && !this.offersCache[product.id]) {
                this.fetchOffers(product);
            }
        },

        fetchOffers(product) {
            this.offersLoading[product.id] = true;

            axios.get('/api/product/' + product.id + '/offer')
                .then(({data}) => {
                    this.offersCache[product.id] = data.data;
                })
                .catch(() => {
                    this.toast.error('Não foi possível carregar as ofertas deste produto.');
                    this.expanded[product.id] = false;
                })
                .finally(() => {
                    this.offersLoading[product.id] = false;
                });
        },

        openOfferModal(offer) {
            this.selectedOffer = offer;
            this.showOfferModal = true;
        },
    }
}
</script>
